/**
 * Canonical hook for config filename decoding.
 * Replaces duplicate inline DECODE_CONFIG_FILENAME in architect/ + dev/ RegistryExplorerPage.
 */

import { useLazyQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

export const DECODE_CONFIG_FILENAME = gql`
  query DecodeConfigFilename($filename: String!) {
    decodeConfigFilename(filename: $filename) {
      filename
      valid
      configType
      prefix
      symbol
      segments {
        dimension
        rawCode
        decodedValue
      }
      error
    }
  }
`;

export interface DecodedSegment {
  dimension: string;
  rawCode: string;
  decodedValue: string;
}

export interface DecodedFilename {
  filename: string;
  valid: boolean;
  configType: string | null;
  prefix: string | null;
  symbol: string | null;
  segments: DecodedSegment[];
  error: string | null;
}

interface DecodeData {
  decodeConfigFilename: DecodedFilename;
}

export function useDecodeConfigFilename() {
  const [decode, { data, loading, error }] = useLazyQuery<DecodeData>(
    DECODE_CONFIG_FILENAME
  );

  return {
    decode: (filename: string) => decode({ variables: { filename } }),
    result: data?.decodeConfigFilename ?? null,
    loading,
    error,
  };
}
